module.exports = __webpack_public_path__ + "img/f-7-1.2cca2e77.png";